
/** 
* 一维数组转二维数组
* @params {number} seetings.windowWidth 窗口宽度
* @params {number} seetings.broadsideWidth 侧边宽度
* @params {number} seetings.tablewidth 表格宽度
* @params {number} seetings.maxCount 每行个数
* @params {Array} oneDtable 一维数组 
*/
export const useTDArray = (seetings, oneDtable) => {
    const { windowWidth, broadsideWidth, tablewidth, maxCount } = seetings;
    // 一行可以放几个表格
    let rowIndex = Math.floor((windowWidth - broadsideWidth) / tablewidth);
    if (maxCount) {
        rowIndex = rowIndex > maxCount ? maxCount : rowIndex;
    }

    const list = [];

    const count = Math.ceil(oneDtable.length / rowIndex);

    for (let i = 1; i <= count; i += 1) {
        const start = (i - 1) * rowIndex;
        const end = i * rowIndex;
        list.push(oneDtable.slice(start, end));
    }
    return list;
};